module.exports = __webpack_public_path__ + "static/ma-4-5c1ec06a7e9d18cb8d4ccac16ebc2ef8.png";